// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-toggle-button {
  align-items: center;
  color: rgba(0, 0, 0, .9);
  color: var(--text-primary-color,rgba(0, 0, 0, .9));
  display: inline-flex;
  white-space: nowrap;
}

.bolt-toggle-button-pill {
  align-items: center;
  background-color: transparent;
  border: 1px solid rgba(0, 0, 0, .55);
  border: 1px solid var(--text-secondary-color,rgba(0, 0, 0, .55));
  border-radius: 0.75rem;
  display: flex;
  justify-content: flex-start;
  padding: 0.2rem;
  width: 2.5rem;
}
.bolt-toggle-button-pill:focus {
  outline: none;
}
@media (forced-colors: active) {
  .bolt-toggle-button-pill:focus {
    forced-color-adjust: none;
    border-color: highlight;
  }
}
@media screen and (forced-colors: active) and (prefers-color-scheme: light) {
  .bolt-toggle-button-pill:focus {
    outline: 1px solid highlight;
    outline-offset: 1px;
  }
}

.bolt-toggle-button-icon {
  background-color: rgba(0, 0, 0, .55);
  background-color: var(--text-secondary-color,rgba(0, 0, 0, .55));
  border: 1px solid transparent;
  border-radius: 50%;
  height: 0.75rem;
  left: 0%;
  position: relative;
  transition: left 0.1s;
  width: 0.75rem;
}
@media (forced-colors: active) {
  .bolt-toggle-button-icon {
    forced-color-adjust: none;
    border-color: windowtext;
  }
}

.bolt-toggle-button.disabled {
  cursor: default;
}

.bolt-toggle-button.disabled .bolt-toggle-button-pill {
  border-color: rgba( 200, 200, 200 ,  1 );
  border-color: rgba( var(--palette-neutral-20,200, 200, 200) ,  1 );
}
@media (forced-colors: active) {
  .bolt-toggle-button.disabled .bolt-toggle-button-pill {
    forced-color-adjust: none;
    border-color: graytext;
  }
}

.bolt-toggle-button.disabled .bolt-toggle-button-icon {
  background-color: rgba( 200, 200, 200 ,  1 );
  background-color: rgba( var(--palette-neutral-20,200, 200, 200) ,  1 );
}

.bolt-toggle-button.checked .bolt-toggle-button-pill {
  background-color: rgba(0, 120, 212, 1);
  background-color: var(--communication-background,rgba(0, 120, 212, 1));
  border-color: transparent;
}
@media (forced-colors: active) {
  .bolt-toggle-button.checked .bolt-toggle-button-pill {
    forced-color-adjust: none;
    background-color: highlight;
  }
}
body.ms-vss-web-vsts-theme-hc-dark .bolt-toggle-button.checked .bolt-toggle-button-pill {
  background-color: rgba(0, 90, 158, 1);
  background-color: var(--communication-foreground,rgba(0, 90, 158, 1));
}
body.ms-vss-web-vsts-theme-hc-light .bolt-toggle-button.checked .bolt-toggle-button-pill {
  background-color: rgba(0, 90, 158, 1);
  background-color: var(--communication-foreground,rgba(0, 90, 158, 1));
}

.bolt-toggle-button.checked .bolt-toggle-button-icon {
  background-color: rgba( 255, 255, 255 ,  1 );
  background-color: rgba( var(--palette-neutral-0,255, 255, 255) ,  1 );
  left: 63%;
}
body.ms-vss-web-vsts-theme-hc-dark .bolt-toggle-button.checked .bolt-toggle-button-icon {
  background-color: rgba(0, 120, 212, 1);
  background-color: var(--communication-background,rgba(0, 120, 212, 1));
}
body.ms-vss-web-vsts-theme-hc-light .bolt-toggle-button.checked .bolt-toggle-button-icon {
  background-color: rgba(0, 120, 212, 1);
  background-color: var(--communication-background,rgba(0, 120, 212, 1));
}

.bolt-toggle-button.checked.disabled .bolt-toggle-button-pill {
  background-color: rgba( 200, 200, 200 ,  1 );
  background-color: rgba( var(--palette-neutral-20,200, 200, 200) ,  1 );
}
@media (forced-colors: active) {
  .bolt-toggle-button.checked.disabled .bolt-toggle-button-pill {
    forced-color-adjust: none;
    background: graytext;
    border-color: graytext;
  }
}

.bolt-toggle-button-text {
  padding-left: 8px;
}

.bolt-focus-visible .bolt-toggle-button-pill.bolt-focus-treatment:focus {
  animation: ms-focus-shadow-pulse 4s ease-in-out infinite;
}
@media (forced-colors: active) {
  .bolt-focus-visible .bolt-toggle-button-pill.bolt-focus-treatment:focus {
    animation: none;
  }
}
.bolt-focus-visible .bolt-toggle-button-pill.bolt-focus-treatment:focus {
  box-shadow: 0 0 0 3px rgba(0, 120, 212, 0.23);
  box-shadow: 0 0 0 3px var(--focus-pulse-max-color,rgba(0, 120, 212, 0.23));
  border-color: rgba(0, 120, 212, 1);
  border-color: var(--communication-background,rgba(0, 120, 212, 1));
  border-radius: 12px;
}
@media (forced-colors: active) {
  .bolt-focus-visible .bolt-toggle-button-pill.bolt-focus-treatment:focus {
    forced-color-adjust: none;
    border-color: highlight;
  }
}

.bolt-focus-visible .checked .bolt-toggle-button-pill.bolt-focus-treatment:focus {
  animation: ms-focus-shadow-with-border-pulse 4s ease-in-out infinite;
}
@media (forced-colors: active) {
  .bolt-focus-visible .checked .bolt-toggle-button-pill.bolt-focus-treatment:focus {
    animation: none;
  }
}
.bolt-focus-visible .checked .bolt-toggle-button-pill.bolt-focus-treatment:focus {
  box-shadow: 0 0 0 3px rgba(0, 120, 212, 0.23), 0 0 0 1px rgba(0, 120, 212, 1);
  box-shadow: 0 0 0 3px var(--focus-pulse-max-color,rgba(0, 120, 212, 0.23)), 0 0 0 1px var(--focus-border-color,rgba(0, 120, 212, 1));
  border-color: rgba(255, 255, 255, 1);
  border-color: var(--background-color,rgba(255, 255, 255, 1));
}
@media (forced-colors: active) {
  .bolt-focus-visible .checked .bolt-toggle-button-pill.bolt-focus-treatment:focus {
    forced-color-adjust: none;
    border-color: highlight;
  }
}

/*# sourceMappingURL=Toggle.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/Toggle/Toggle.scss","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss","webpack://./../azure-devops-ui/bin/Components/Toggle/Toggle.css","webpack://./../azure-devops-ui/src/_coreStyles.scss"],"names":[],"mappings":"AACA;EACI,mBAAA;EACA,wBC0JW;EDzJX,kDAAA;EACA,oBAAA;EEAF,mBAAmB;AACrB;;AAEA;EFEI,mBAAA;EACA,6BAAA;EACA,oCAAA;EACA,gEAAA;EACA,sBAAA;EACA,aAAA;EACA,2BAAA;EEAF,eAAe;EFEb,aAAA;AEAJ;AACA;EC4BI,aAAA;AD1BJ;AACA;EACE;IACE,yBAAyB;IACzB,uBAAuB;EC+DvB;AD7DJ;AACA;EACE;IACE,4BAA4B;IAC5B,mBAAmB;EACrB;AFRF;;AEWA;EFRI,oCAAA;EACA,gEAAA;EACA,6BAAA;EACA,kBAAA;EACA,eAAA;EACA,QAAA;EEUF,kBAAkB;ECKhB,qBAAA;EHvBJ,cAAA;AEqBA;AACA;EACE;IACE,yBAAyB;IACzB,wBAAwB;EFT5B;AEWA;;AAEA;EFTA,eAAA;AEWA;;ACRI;EHHJ,wCAAA;EEeE,kEFZM;AEaR;AACA;EACE;IACE,yBAAyB;IFX7B,sBAAA;EACI;AEaJ;;AFVA;EACI,4CCjCuB;EDkCvB,sEAAA;AEaJ;;AAEA;EACE,sCFdM;EEeN,sEFdM;EEeN,yBAAyB;AAC3B;AD6TQ;ED1UA;IEgBJ,yBAAyB;ID6TrB,2BAAA;ED7UA;AEmBR;AACA;EFhBA,qCAAA;EACI,qEC4BI;ACVR;AACA;EDkTQ,qCAAA;EDjUA,qECjDmB;ACmE3B;;AAEA;EACE,4CAA4C;EAC5C,qEAAqE;EFlBvE,SAAA;AEoBA;AACA;ECnDI,sCAAA;EH8BJ,sEAAA;AEwBA;AACA;EACE,sCFpBM;EEqBN,sEAAsE;AACxE;;AFlBA;EACI,4CAAA;EEqBF,sEAAsE;AACxE;AFnBA;EGjCQ;IDuDJ,yBAAyB;IClEzB,oBAAA;IH4CJ,sBAAA;EEyBE;AACF;;AF1BA;EGrBQ,iBAAA;ADmDR;;AAEA;EC5EI,wDAAA;AD8EJ;AACA;EACE;IACE,eAAe;EACjB;AACF;AF7BA;EG7CQ,6CAAA;ED6EN,0EAA0E;ECtFxE,kCAAA;EHsDJ,kEAAA;EEmCE,mBC1EM;AD2ER;AACA;EFrCA;IGjCQ,yBAAA;IHmCJ,uBCkDc;ECXhB;AC/FE;;ADkGJ;EACE,oEFxCM;AEyCR;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,6EAA6E;EAC7E,oIAAoI;EACpI,oCAAoC;EACpC,4DAA4D;AAC9D;AACA;EACE;IACE,yBAAyB;IACzB,uBAAuB;EACzB;AACF;;AAEA,qCAAqC","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
